import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';

import './data-privacy-request-content.scss';

export const DataPrivacyRequestContent = ({ children = '', className = '', id = undefined }) => {
  return (
    <ContentFragment classes={classnames('data-privacy-request-content', className)} id={id}>
      {children}
    </ContentFragment>
  );
};

DataPrivacyRequestContent.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  id: PropTypes.string,
};
